import React from "react"
import {Box, Paper, Stack, Typography} from "@mui/material"
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined"
import PlaylistAddCheckRoundedIcon from "@mui/icons-material/PlaylistAddCheckRounded"
import SideBarLayout from "../../../layout/side-bar-layout"
import {TITLE_DESIGN_SYSTEM_PAGE} from "../../../../utils/constants"
import FormSectionAccordion from "../../../components/FormSectionAccordion"
import ButtonWithIcon from "../../../components/Button/Button"
import CodeViewer from "../../../components/CodeViewer/code-viewer"
import {ReactComponent as CheckIcon} from "src/v2/assets/icons/check-icon.svg"

const FormSectionsDesignSystemPage = () => {
    const TITLE_PAGE = `${TITLE_DESIGN_SYSTEM_PAGE} | Form Section Accordion`

    const downloadAction = (
        <ButtonWithIcon
            size="sm"
            variant="outlined"
            icon={<FileDownloadOutlinedIcon />}
        >
            Exportar seção
        </ButtonWithIcon>
    )

    const codeSectionExample = `import { ReactComponent as CheckIcon } from "src/v2/assets/icons/check-icon.svg"
import FormSectionAccordion from "src/v2/components/FormSectionAccordion"
import ButtonWithIcon from "src/v2/components/Button/Button"
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined"

<FormSectionAccordion
  title="Oferta"
  icon={<CheckIcon style={{ width: 20, height: 20 }} />}
  actions={
    <ButtonWithIcon
      size="sm"
      variant="outlined"
      icon={<FileDownloadOutlinedIcon />}
    >
      Exportar seção
    </ButtonWithIcon>
  }
  isValid={ofertaValida}
  defaultOpen
>
  {/* grade de campos da seção Oferta */}
</FormSectionAccordion>`

    const codeProps = `type FormSectionAccordionProps = {
  title: string
  icon?: React.ReactNode
  children: React.ReactNode
  actions?: React.ReactNode       // exibe ações no canto direito do cabeçalho
  defaultOpen?: boolean           // abre a seção logo ao montar o componente
  disableBorder?: boolean         // true: inativa a borda colorida do componente
  disableIcon?: boolean           // true: inativa o icone default do componente
  header?: elemente               // Possibilita informar um componente customizado no header
}`

    return (
        <SideBarLayout
            header
            title={TITLE_PAGE}
            headerTitle={TITLE_PAGE}
        >
            <Box sx={{mt: -2}}>
                <Stack spacing={3}>
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h4" gutterBottom color="common.white">
                                {`FormSectionAccordion`}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {`Componente usado para agrupar campos em blocos colapsáveis com feedback visual de validação, como visto no Cadastro Manual e OCR.`}
                            </Typography>

                            <Box sx={{backgroundColor: "#14192b", p: 2, borderRadius: 1, mt: 3}}>
                                <Stack spacing={2}>
                                    <FormSectionAccordion
                                        title="Características"
                                        actions={downloadAction}
                                        isValid={false}
                                        defaultOpen
                                    >
                                        <Typography variant="body2" color="text.secondary">
                                            {`Exemplo com estado inválido: a borda fica vermelha quando há campos obrigatórios faltando.`}
                                        </Typography>
                                    </FormSectionAccordion>

                                    <FormSectionAccordion
                                        title="Oferta"
                                        icon={<CheckIcon style={{color: "#fff", width: 20, height: 20}} />}
                                        isValid
                                    >
                                        <Typography variant="body2" color="text.secondary">
                                            {`Exemplo validado: borda verde e ícone customizado, seguindo o uso real do cadastro manual.`}
                                        </Typography>
                                    </FormSectionAccordion>

                                    <FormSectionAccordion
                                        title="Garantias"
                                        actions={
                                            <ButtonWithIcon
                                                size="sm"
                                                variant="outlined"
                                                icon={<PlaylistAddCheckRoundedIcon />}
                                            >
                                                Validar seção
                                            </ButtonWithIcon>
                                        }
                                    >
                                        <Typography variant="body2" color="text.secondary">
                                            {`Sem isValid definido, a borda amarela indica que a seção ainda não foi validada.`}
                                        </Typography>
                                    </FormSectionAccordion>

                                    <FormSectionAccordion
                                        title="Sem ícone"
                                        disableIcon
                                        icon={<CheckIcon style={{color: "#fff", width: 20, height: 20}} />}
                                        isValid
                                    >
                                        <Typography variant="body2" color="text.secondary">
                                            {`Exemplo validado: borda verde e ícone customizado, seguindo o uso real do cadastro manual.`}
                                        </Typography>
                                    </FormSectionAccordion>

                                    <FormSectionAccordion
                                        title="sem borda"
                                        disableBorder
                                        icon={<CheckIcon style={{color: "#fff", width: 20, height: 20}} />}
                                        isValid
                                    >
                                        <Typography variant="body2" color="text.secondary">
                                            {`Exemplo validado: borda verde e ícone customizado, seguindo o uso real do cadastro manual.`}
                                        </Typography>
                                    </FormSectionAccordion>

                                    <FormSectionAccordion
                                        disableBorder
                                        disableIcon
                                        header={<Box sx={{ml: 14, color: "#fff"}}>Header Custom</Box>}
                                        icon={<CheckIcon style={{color: "#fff", width: 20, height: 20}} />}
                                        isValid
                                    >
                                        <Typography variant="body2" color="text.secondary">
                                            {`Exemplo validado: borda verde e ícone customizado, seguindo o uso real do cadastro manual.`}
                                        </Typography>
                                    </FormSectionAccordion>
                                </Stack>
                            </Box>
                        </Box>
                    </Paper>

                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Exemplo inspirado no cadastro manual`}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Estrutura típica com título, ícone e ação de exportar. Esse padrão é o mesmo usado nas seções do Cadastro Manual/OCR.`}
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeSectionExample} language="jsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Propriedades principais`}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`API simplificada do FormSectionAccordion para consulta rápida.`}
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeProps} language="tsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>
                </Stack>
            </Box>
        </SideBarLayout>
    )
}

export default FormSectionsDesignSystemPage
